module.exports = __webpack_public_path__ + "static/media/eye.02e68e8f.svg";